import type { TFunction } from "i18next";
import { DOCUMENT_TYPE } from "../enums";

/** Returns "Add to order" / "Add to quote" label based on document type. */
export function getAddToDocumentButtonLabel(
  documentType: number | string | string[] | undefined | null,
  t: TFunction,
): string {
  const value = Array.isArray(documentType) ? documentType[0] : documentType;

  return Number(value) === DOCUMENT_TYPE.order
    ? t("products.offsetPrice.admin.addOrderBtn")
    : t("products.offsetPrice.admin.addQuoteBtn");
}
